// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import PatientReadings from "@/components/PatientReadings";
import LoaderWrapper from "./LoaderWrapper";
import { useAuth } from "@/contexts/use-auth";

export default function PatientDevicePage() {
  const { user, profile, isLoading } = useAuth();
  // Use profile from auth/me API as patient data (has _id, typeOfPatient, etc.)
  const patient = user?.role === "patient" ? profile : null;

  return (
    <DashboardLayout activePage="/patient-device">
      {isLoading && <LoaderWrapper />}
      {!isLoading && (user?.role !== "patient" || !patient) && (
        <div className="flex items-center justify-center min-h-[200px] text-muted-foreground">
          {user?.role !== "patient"
            ? "Access restricted to patients."
            : "No devices available."}
        </div>
      )}
      {!isLoading && patient && (
        <PatientReadings
          patient={patient}
          showOnlyAssignedDeviceTabs={
            patient?.typeOfPatient === "outpatient"
          }
        />
      )}
    </DashboardLayout>
  );
}
